import type { Integration } from "@repo/api";
import { Button, Icon, Tooltip } from "@saviynt/design-system";
import { FormattedMessage, useIntl } from "react-intl";
import { useRouting } from "../../contexts/RoutingContext";

interface IntegrationSidePanelFooterProps {
  integration: Integration;
  onDeleteClick: () => void;
}

export function IntegrationSidePanelFooter({
  integration,
  onDeleteClick,
}: IntegrationSidePanelFooterProps) {
  const intl = useIntl();
  const { handleEditIntegration } = useRouting();

  const handleEditClick = () => {
    handleEditIntegration(String(integration.id), integration.integrationType);
  };

  return (
    <div className="flex items-center justify-end gap-2 px-6 w-full Integrations-sidePanel-footer">
      <Button
        kind="subtle"
        leftIcon={<Icon kind="Edit" size="small" />}
        onClick={handleEditClick}
      >
        <FormattedMessage
          id="2rcoOT"
          defaultMessage="Edit"
          description="Edit button label"
        />
      </Button>
      <Tooltip
        text={intl.formatMessage({
          id: "PSTccr",
          defaultMessage: "Delete Integration",
          description: "Delete integration menu item",
        })}
        isPortalEnabled
      >
        <Button
          kind="outlined"
          size="medium"
          leftIcon={<Icon kind="Delete" size="small" />}
          ariaLabel={intl.formatMessage({
            id: "PSTccr",
            defaultMessage: "Delete Integration",
            description: "Delete integration menu item",
          })}
          onClick={onDeleteClick}
        >
          <FormattedMessage
            id="WodcPq"
            defaultMessage="Delete"
            description="Delete button label"
          />
        </Button>
      </Tooltip>
    </div>
  );
}
